import React, {useState, useEffect} from 'react';
import {InquiryForm} from '../packages';
import {IconInput, DatePicker} from '../shared';
import {passCsrfToken} from '../../helpers';
import * as yup from 'yup';
import {Formik, Form, Field} from 'formik';
import ErrorMessage from '../ErrorMessage';
import {Dropdown} from 'semantic-ui-react';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import {Input} from 'semantic-ui-react';
import moment from 'moment';
import ReactDOM from 'react-dom';
import axios from 'axios';
import {getPartners} from '../../api/partnerApi';
import {confirmInquiry, showInquiry} from '../../api/inquiryApi';
import {Tab, Checkbox} from 'semantic-ui-react';
import PartnerServiceForm from './PartnerServiceForm';
import {showPackage} from '../../api/packageApi';

const EditInquiry = (props) => {
	const [aPackage, setPackage] = useState({
		price: 0,
		addons: []
	});
	const [inquiry, setInquiry] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const idx = props.match.params.idx;
		const fromState = props.location.state && props.location.state.inquiry;
		
		if (fromState && fromState.idx === idx) {
			setInquiry(fromState);
			if (fromState.package && fromState.package.idx) {
				showPackage(fromState.package.idx).then((v) => {
					setPackage(v.data || { price: 0, addons: [] });
					setLoading(false);
				}).catch(() => {
					setLoading(false);
				});
			} else {
				setLoading(false);
			}
		} else {
			showInquiry(idx).then((v) => {
				const inq = v.data;
				setInquiry(inq);
				if (inq.package && inq.package.idx) {
					showPackage(inq.package.idx).then((r) => {
						setPackage(r.data || { price: 0, addons: [] });
						setLoading(false);
					}).catch(() => {
						setLoading(false);
					});
				} else {
					setLoading(false);
				}
			}).catch(() => {
				setLoading(false);
			});
		}
	}, [props.match.params.idx]);

	if (loading) {
		return <div className='container p-4'>Loading...</div>;
	}

	if (!inquiry) {
		return <div className='container p-4'><div className='alert alert-warning'>Inquiry not found.</div></div>;
	}

	return (
		<div className='container'>
			<h3 className='title mb-3'>Edit Inquiry</h3>
			<div className='card'>
				<div className='card-body'>
					<InquiryForm inquiry={inquiry} aPackage={aPackage} />
				</div>
			</div>
		</div>
	);
};
export default EditInquiry;
